module.exports = __webpack_public_path__ + "static/media/12.caff4fff.jpg";